export default __webpack_public_path__ + "static/media/happy_hour.cb40a612.jpg";